<template>
  <ReportFilterSelect
    v-model="modelValue"
    label="Cashier"
    :options="options"
    class="w-full"
  />
</template>

<script setup lang="ts">
const modelValue = defineModel<string | undefined>({
  required: true,
})

const { options } = useCashierOptions()
</script>
